import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SKIP = /^\/(admin|manette|signup|auth|verify-code|faq|cgu|confidentialite|mentions-legales|activate|go)/;
const PAGE_LABELS = { '/': 'Accueil', '/search': 'Recherche', '/my-list': 'Ma liste', '/browse': 'Parcourir', '/account': 'Compte', '/account/settings': 'Paramètres', '/tv': 'Accueil TV' };

export function actSid() {
  let s = sessionStorage.getItem('act_sid');
  if (!s) {
    s = (window.crypto?.randomUUID && window.crypto.randomUUID()) || Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem('act_sid', s);
  }
  return s;
}

const profId = () => {
  try { return JSON.parse(sessionStorage.getItem('activeProfile') || 'null')?.id || ''; } catch { return ''; }
};

export function trackEvent(type, page, contentId = '') {
  axios.post(`${API}/activity/event`, {
    session_id: actSid(), type, page, content_id: contentId, profile_id: profId(),
    device_hint: sessionStorage.getItem('tvMode') === '1' ? 'tv' : '',
  }, { withCredentials: true }).catch(() => {});
}

export default function ActivityTracker() {
  const location = useLocation();
  const { user } = useAuth();
  const lastPath = useRef('');

  useEffect(() => {
    if (!user) return;
    const ping = () => {
      const p = window.location.pathname;
      if (SKIP.test(p)) return;
      axios.post(`${API}/activity/ping`, {
        session_id: actSid(), profile_id: profId(), page: p,
        device_hint: sessionStorage.getItem('tvMode') === '1' ? 'tv' : '',
      }, { withCredentials: true }).catch(() => {});
    };
    ping();
    const iv = setInterval(ping, 60000);
    return () => clearInterval(iv);
  }, [user]);

  useEffect(() => {
    if (!user) return;
    const p = location.pathname;
    if (SKIP.test(p) || p === lastPath.current) return;
    lastPath.current = p;
    let type = 'nav', contentId = '', page = PAGE_LABELS[p] || p;
    const w = p.match(/^\/watch\/(.+)$/);
    const g = p.match(/^\/game\/(.+)$/);
    const c = p.match(/^\/content\/(.+)$/);
    if (w) { type = 'play'; contentId = w[1]; page = 'Lecture'; }
    else if (g) { type = 'play'; contentId = g[1]; page = 'Jeu'; }
    else if (c) { type = 'content_view'; contentId = c[1]; page = 'Fiche contenu'; }
    trackEvent(type, page, contentId);
  }, [location, user]);

  return null;
}
